import { ErrorNotice } from './ErrorNotice';

/**
 * Die drei Zustände einer Abfrage an einer Stelle.
 *
 * Bis hierher standen Lade-, Fehler- und Leerzustand in jeder Ansicht neu und
 * jedes Mal etwas anders. Das ist weniger eine Frage der Zeilenzahl als eine der
 * Verlässlichkeit: Ein Leerzustand, der nur in zwei von vier Ansichten erklärt,
 * was als Nächstes zu tun wäre, ist schlechter als gar keiner.
 */
export function AsyncBoundary<T>({
  query,
  empty,
  children,
}: {
  query: { isPending: boolean; isError: boolean; error: unknown; data: T | undefined };
  /** Wird gezeigt, wenn die Abfrage eine leere Liste liefert. */
  empty?: React.ReactNode;
  children: (data: T) => React.ReactNode;
}) {
  if (query.isPending) return <p className="text-sm text-slate-500">Wird geladen …</p>;
  if (query.isError) return <ErrorNotice error={query.error} />;
  if (query.data === undefined) return null;

  if (empty && Array.isArray(query.data) && query.data.length === 0) {
    return (
      <div className="rounded-lg border border-slate-200 bg-white p-8 text-center text-sm text-slate-500">
        {empty}
      </div>
    );
  }

  return <>{children(query.data)}</>;
}
